var map = {
	"./black/baojingjiechu.png": "VC5S",
	"./blue/baojingjiechu.png": "S9j3",
	"./white/baojingjiechu.png": "MolK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zE1r";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/baojingjiechu\.png$
// module id = zE1r
// module chunks = 24